export default __webpack_public_path__ + "static/media/IMG_0009_17_11zon.6769e926.jpg";